import { FC } from 'react'
import { useQuery } from 'react-query'
import { fetchArtistById } from 'src/services'
import Loading from 'src/components/Loading/Loading'
import Layout from 'src/containers/Layout/Layout'
import ArtistDetailContainer from 'src/containers/Artist/ArtistDetail'

const ArtistDetailPage: FC = () => {
  const { data, isFetching, isLoading } = useQuery('artist', () =>
    fetchArtistById(window.location.pathname.replace('/artist/', '')),
  )
  if (isFetching || isLoading || !data) return <Loading />

  return (
    <Layout>
      <ArtistDetailContainer artist={data} />
    </Layout>
  )
}

export default ArtistDetailPage
